export const TABS = [
  {
    id: 'PRODUCT',
    title: 'Produit et service',
  },
  {
    id: 'FAQ',
    title: 'FAQ',
  },
  {
    id: 'BLOG',
    title: 'Blog',
  },
  {
    id: 'MARKET',
    title: 'Bourse',
  },
] as const

export type TabId = (typeof TABS)[number]['id']

export const usefulLinks = [
  {
    label: 'Formulaires',
    url: '/formulaires',
  },
  {
    label: 'Offres spéciales',
    url: '/offres-speciales-fortuneo',
  },
  {
    label: 'Parrainage',
    url: '/parrainage',
  },
  {
    label: 'Conditions tarifaires',
    url: '/tarifs',
  },
]
